import React from "react";
import {FormikProps} from "formik";
import {Grid, TextField} from "@mui/material";
import {get} from "lodash";
import {getFormErrorText} from "../../utils/getFormTextError";
import {GridTypeMap} from "@mui/material/Grid/Grid";
import {DatePicker, DatePickerProps} from "@mui/x-date-pickers";
import {TFunction} from "i18next";
import dayjs from "dayjs";
import {DateFormat, DateUnitType} from "../../utils/datetime";
import {getIsValidDate} from "../../utils/getIsValidDate";

export interface FormDatePickerProps
    extends Omit<DatePickerProps<string, string>, "value" | "onChange" | "renderInput"> {
    fieldName: string;
    form: FormikProps<any>;
    value?: string;
    label: string;
    isGridItem?: boolean;
    t: TFunction;
    gridProps?: GridTypeMap["props"];
}

const FormDatePicker = ({
    fieldName,
    label,
    value,
    form,
    t,
    isGridItem = false,
    gridProps = {xs: 6},
    mask = "____-__-__",
    inputFormat = DateFormat.DATE,
    ...rest
}: FormDatePickerProps) => {
    const getField = () => (
        <DatePicker
            value={get(form.values, fieldName)}
            renderInput={(props) => (
                <TextField
                    {...props}
                    name={fieldName}
                    onBlur={() => form.setFieldTouched(fieldName, true, false)}
                    error={!!getFormErrorText(form, fieldName)}
                    helperText={getFormErrorText(form, fieldName)}
                    label={label}
                />
            )}
            onChange={(dateValue) => {
                const newValue = getIsValidDate(dateValue)
                    ? dayjs(dateValue).endOf(DateUnitType.DAY).format()
                    : dateValue;
                form.setFieldValue(fieldName, newValue, true);
            }}
            mask={mask}
            inputFormat={inputFormat}
            {...rest}
        />
    );

    return isGridItem ? (
        <Grid item {...gridProps}>
            {getField()}
        </Grid>
    ) : (
        getField()
    );
};

export default FormDatePicker;
